import React, { useEffect, useContext, useState } from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';
import
{ BarChartContainer, } from './PrintStats.styles';
import './PrintStats.css';
import { colors } from '../../../options/colors';
import { indexAccordionOptions } from '../../../options/indexAccordionOptions';
import { drillStatsToggleOptions } from '../../../options/drillStatsToggleOptions';
import MainWrapper from '../../../components/Wrappers/PrintWrapper/PrintWrapper';
import SectionContainer from '../../../components/Containers/PrintSectionContainer/PrintSectionContainer';
import BarChartLegend from '../../../components/StatsPage/BarChartLegend/BarChartLegend';
import PrintRadarChart from '../../../components/Charts/PrintRadarChart/PrintRadarChart';

// Contexts & Helpers
import { BaseContext } from '../../../providers/Global/BaseProvider';

import { createColorHex } from '../../../utils/helpers/createColorHex';
import { formatStandardDateString } from '../../../utils/helpers/formatDateString';
import { createPlayerStatsObject, createDrillStatsProgrammes, fetchDrillStatsProgrammes } from '../../../utils/helpers/drillStatsHelper';


// API Calls
import { getLatestProgrammeStats, getClubPlayerProfile, getDrillSummaryStats, getIndexSummaryStats } from '../../../api';
import { routes } from '../../../options/routes';

import { RadarChartContainer } from '../IndexStats/IndexStats.styles';
import { PrintStatsContext } from '../../../providers/Index/PrintStatsProvider';
import PrintStatsStat from '../../../components/StatsPage/PrintStatsStat/PrintStatsStat';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import PrintStatsLeaderboard from '../../../components/StatsPage/PrintStatsLeaderboard/PrintStatsLeaderboard';

import PrintBarChart from '../../../components/Charts/PrintBarChart/PrintBarChart';
import PrintLineChart from '../../../components/Charts/PrintLineChart/PrintLineChart';

import RezzilLogoBlack from '../../../components/Avatars/RezzilLogoBlack/RezzilLogoBlack';
import ChartImage from '../../../components/Charts/ChartImage/ChartImage';
import { getNewPlayerStats } from '../../../utils/helpers/indexStatsHelpers';
import { getCacheIndexSummaryStats } from '../../../utils/helpers/statsHelper';
import { formatDate } from '../../../utils/helpers/pdfPrintStatsHelper';

const getInitialAvgIndexStats = (playerName, programmeStats, scores, worldbestScores) =>
{
  // Get initial avg stats to display in Average Index Stats section on page load (for logged in player)
  const color = createColorHex(playerName);
  programmeStats.forEach((stat, idx) =>
  {
    // Reset scores and worldScore values before setting initial stats
    stat.playerScores = [];
    stat.worldScore = '';
    const scoreData = {
      color,
      score: scores[idx],
    };

    stat.playerScores.push(scoreData);
    if (worldbestScores)
    {
      stat.worldScore = worldbestScores[stat.id] ? Math.round(worldbestScores[stat.id] * 100) / 100 : '--';
    }
  });
  return { programmeStats, color };
};

const PrintStats = () =>
{
  const params = useParams();

  const baseContext = useContext(BaseContext);
  const printStatsContext = useContext(PrintStatsContext);
  const [dataLoading, setDataLoading] = useState(true);
  const [playerDataLoading, setPlayerDataLoading] = useState(false);
  const [drillDataLoading, setDrillDataLoading] = useState(true);
  const [indexDataLoading, setIndexDataLoading] = useState(true);
  const [shareLoading, setShareLoading] = useState(false);
  const [indexChartDataLoading, setIndexChartDataLoading] = useState(false);
  const [drillChartDataLoading, setDrillChartDataLoading] = useState(true);

  const [selectedPlayer, setSelectedPlayer] = useState();
  const [playerStatsList, setPlayerStatsList] = useState([]);
  const [playerIndexStatsList, setPlayerIndexStatsList] = useState([]);
  const [playerAvgData, setPlayerAvgData] = useState([]);
  const [playerAvgData2, setPlayerAvgData2] = useState([]);
  const [playerAvgDataArr, setPlayerAvgDataArr] = useState([]);
  const [selectedDrillId, setSelectedDrillId] = useState('');
  const [selectedDrillName, setSelectedDrillName] = useState('');
  const [programmeStatsData, setProgrammeStatsData] = useState([]);
  const [avgGameStats, setAvgGameStats] = useState([]);
  const [drillSessionStatsData, setDrillSessionStatsData] = useState([]);
  const [clubLeaderboard, setClubLeaderboard] = useState();
  const [allProgrammeSessionsData, setAllProgrammeSessionsData] = useState([]);
  const [latestProgrammeSessionDeepData, setLatestProgrammeSessionDeepData] = useState([]);
  const [allProgrammeSessionsDeepData, setAllProgrammeSessionsDeepData] = useState([]);
  const [indexBreakdownStats, setIndexBreakdownStats] = useState({});
  const [globalLeaderboard, setGlobalLeaderboard] = useState();
  const [drillChartLabels, setDrillChartLabels] = useState([]);
  const [drilllChartData, setDrillChartData] = useState([]);
  const [lastIndexSessionsData, setLastIndexSessionsData] = useState([]);
  const [lastIndexSessionsLabels, setLastIndexSessionsLabels] = useState([]);

  const [clubName, setClubName] = useState('');
  const [avgIndexStats, setAvgIndexStats] = useState([]);
  const [playerLegendColor, setPlayerLegendColor] = useState('');
  const [sessionsBatchInView, setSessionsBatchInView] = useState(1);
  const [chartAllProgrammeSessions, setChartAllProgrammeSessions] = useState();
  const [sessionDropdownOptions, setSessionDropdownOptions] = useState([]);
  const [chartIndex, setChartIndex] = useState(0);
  const [rectSize, setRectSize] = useState({});
  const [breakdownPlayerOptions, setBreakdownPlayerOptions] = useState([]);
  const [selectedSession, setSelectedSession] = useState('');
  const [allSessionDropdownOptions, setAllSessionDropdownOptions] = useState([]);
  const [reportDate, setReportDate] = useState("");

  const [cachedChartData, setCachedChartData] = useState([]);
  const [error, setError] = useState({
    show: false,
    message: '',
  });

  const getPlayerAvgIndexData = stats =>
  {
    // Convert player avg data to array of int values to render in radar chart
    const avgOptions = [...indexAccordionOptions];
    let averages = [];
    let averages2 = {};
    // We want avgOptions without heartRate
    avgOptions.forEach(e =>
    {
      if (e.statId)
      {
        let key = e.statId;
        averages2[key] = {
          ...e,

        }
        if (stats.bestScore[key])
        {
          averages2[key]['bestScore'] = stats.bestScore[key];
        }
        if (stats.avgScore[key])
        {
          averages2[key]['avgScore'] = stats.avgScore[key];
        }

      }
      if (e.avgStats)
      {
        console.log('drill avergaes ere')
      }

    });
    avgOptions.filter((stat) => stat.statId !== 'heartRate').forEach(({ statId }) =>
    {
      if (stats?.avgScore)
      {
        // TODO: broken
        const avgValue = stats?.avgScore[statId];
        averages.push(isNaN(avgValue) ? '--' : Math.round(stats.avgScore[statId] * 100) / 100);
      }
    });
    setPlayerAvgData2(averages2)
    return averages;
  };

  useEffect(async () =>
  {

    //let renderBlock = document.getElementsByTagName("html")[0];
    let renderBlock = document.getElementById('outer');
    let renderBlockInfo = window.getComputedStyle(renderBlock)
    renderBlockInfo.time = new Date().toLocaleTimeString(
      'en-gb'
    );
    setRectSize(renderBlockInfo);
    setDataLoading(true);
    if (params.playerId && !selectedPlayer)
    {
      /*     const profileData = await getClubPlayerProfile(params.playerId);
          setSelectedPlayer(profileData?.data?.profile);
     */
      //handlePlayerReset()
      // printStatsContext.getIndexStatsData();
      // Reset options and set the logged in player as the first choice
      const playerStatsId = params?.playerId;



      setPlayerDataLoading(true);

      // const latestStats = await getLatestProgrammeStats(rows[0]);
      const profileData = await getClubPlayerProfile(playerStatsId);
      setSelectedPlayer(profileData?.data?.profile);
    }
    if (clubLeaderboard && globalLeaderboard && !avgGameStats.length)
    {
      const playerStatsId = params?.playerId;
      const profileData = await getClubPlayerProfile(playerStatsId);
      //const drillAverageStats = await getDrillSummaryStats(playerStatsId);
      const indexAverageStats = await getCacheIndexSummaryStats(playerStatsId);
      const latestPlayerStats = await getLatestProgrammeStats(playerStatsId)
      const playerStats = createPlayerStatsObject(profileData?.data, indexAverageStats?.data, clubLeaderboard, globalLeaderboard, latestPlayerStats?.data);
      setPlayerStatsList(playerStats);

      // Update relevant stats for player one
      const toggleOptions = [...drillStatsToggleOptions];

      //setPlayerStats(0, playerStats.drillStats);


      // Set drill stats tab and hidden menu options
      setDrillData(playerStats.drillStats);
      const avgDrillStats = getDrillAvgGameStats(toggleOptions, playerStats.avgStats);
      // Set data for averages game stats section

      setAvgGameStats(avgDrillStats);

      // Set chart data for score stat
      const drillStats = await createDrillStatsProgrammes(playerStatsId);
      const sessionStatsData = [drillStats.drillStats ? drillStats.drillStats : drillStats];
      updateChartData(0, sessionStatsData);


      setSelectedDrillId(playerStats.drillStats.length > 0 ? playerStats.drillStats[0].drillId : '');
      setSelectedDrillName(playerStats.drillStats.length > 0 ? playerStats.drillStats[0].drillName : '');


      setPlayerDataLoading(false);
    }


    setReportDate(formatDate(new Date()));

    if (!dataLoading)

      //   setDataLoading(true);
      // Set tab and menu options dynamically as screen width breakpoint threshold is hit
      if (playerStatsList?.length && playerStatsList?.drillStats?.length > 0)
      {
        const drillOptions = getDrillOptions(playerStatsList.drillStats);

      }

    if (printStatsContext.indexStatsData?.allLoaded && !clubLeaderboard)
    {
      setDataLoading(false);

      if (printStatsContext.indexStatsData.apiError)
      {
        setError({
          show: true,
          message: 'Unable to load some or all page content. Please refresh and try again.'
        });
      }


      // Get data from PrintStatsContext
      const {
        playerProfiles,
        allProgrammeSessions,
        allProgrammeSessionsDeep,
        programmeSessionStats,
        playerStats,
        indexBreakdownData,
        clubLeaderboard,
        globalLeaderboard,
        worldAvgStats,
      } = printStatsContext.indexStatsData;

      setClubLeaderboard(clubLeaderboard);
      setGlobalLeaderboard(globalLeaderboard);
      // Add logged in player id to p
      //const { success, newPlayerStats } = await getNewPlayerStats(id, clubLeaderboard, globalLeaderboard);
      // Set initial player stats for the logged in player
      setPlayerIndexStatsList(playerStats);
      console.log('270 stat', playerIndexStatsList);

      // Set initial player stats for the radar chart - do not include heart rate
      const averages = getPlayerAvgIndexData(playerStats);
      setPlayerAvgData(averages);
      setPlayerAvgDataArr([averages]);

      // Set data for average index stats section
      const stats = [];
      const { firstname, lastname } = playerStats;

      const { programmeStats, color } = getInitialAvgIndexStats(
        `${firstname} ${lastname}`, stats, averages, worldAvgStats
      );
      setAvgIndexStats(programmeStats);
      //setPlayerLegendColor(color);

      // Set data for all programmes/sessions, chart data and index breakdown data
      setInitialPlayerData(
        params?.playerId,
        `${firstname} ${lastname}`,
        [],
        allProgrammeSessions,
        allProgrammeSessionsDeep,
        programmeSessionStats,
        indexBreakdownData,
      );
    }
    if (printStatsContext.drillStatsData.allLoaded && !drilllChartData?.data)
    {
      setDataLoading(false);
      const { playerStats, globalLeaderboard, clubLeaderboard, drillStats, allProgrammeSessions } = printStatsContext.drillStatsData;
      const playerProfiles = printStatsContext.drillStatsData.clubProfiles;

      setGlobalLeaderboard(globalLeaderboard);
      setClubLeaderboard(clubLeaderboard);
      setChartAllProgrammeSessions(allProgrammeSessions);


      const { labels, chartData } = getDrillChartData(drillStats);

      setDrillChartData(chartData);
      setDrillChartLabels(labels);
      setDrillChartDataLoading(false);
      // Data from API below:
      setPlayerStatsList(playerStats);

      // const currentUserExists = playerProfiles.find((player) => player.id === id);
      // const selectedId = currentUserExists ? Number(id) : playerProfiles[0] ? Number(playerProfiles[0]?.id) : undefined;
      // TODO: DEAN - properly handle the concept of user-profiles
      //let selectedId = (playerProfiles && playerProfiles.length) ? Number(playerProfiles[0]?.id) : undefined;
      let selectedId = params.playerId;

      if (selectedId)
      {

        // Set comparison stats
        const { name } = baseContext.baseData.clubProfile;
        setClubName(name ? name : '--');

      }


    }
  }, [baseContext, printStatsContext, playerStatsList]);

  const setInitialPlayerData = (
    playerId,
    playerName,
    dropdownOptions,
    allProgrammeSessions,
    allProgrammeSessionsDeep,
    programmeSessionStats,
    indexBreakdownData
  ) =>
  {
    // Set data for all programmes
    let programmeSessionsData = [],
      disablePrevBtn = true;
    if (allProgrammeSessions && allProgrammeSessions.length > 0)
    {
      programmeSessionsData = [allProgrammeSessions];
      if (allProgrammeSessions.length > 10) disablePrevBtn = false;
    }
    setAllProgrammeSessionsData(programmeSessionsData);

    let programmeSessionsDeepData = [],
      latestSessionDeepData = [];
    if (allProgrammeSessionsDeep && allProgrammeSessionsDeep.length > 0)
    {
      // Add empty objects to array to give it a min length of 10 to ensures bar chart click functionality works
      const desiredLength = 10;
      const missingLength = desiredLength - allProgrammeSessionsDeep.length;
      for (let i = 0; i < missingLength; i++)
      {
        allProgrammeSessionsDeep.push({});
      }
      programmeSessionsDeepData = [allProgrammeSessionsDeep];
      latestSessionDeepData = [allProgrammeSessionsDeep[0]];
    }
    setAllProgrammeSessionsDeepData(programmeSessionsDeepData);
    setLatestProgrammeSessionDeepData(latestSessionDeepData);

    // Set stats related to programmeSessionStats if data exists
    let programmeStatsData = [],
      chartLabels = [],
      stateChartData = [],
      breakdownPlayerOptions = [],
      sessionDropdownOptions = [],
      allSessionDropdownOptions = [],
      selectedSession = '';
    if (programmeSessionStats)
    {


      // Set chart data for index programme
      const sessionStatsData = [programmeSessionStats];
      const { labels, chartData } = getIndexChartData(
        'rezzilIndex',
        '',
        sessionStatsData[0]
      );
      programmeStatsData = sessionStatsData;
      chartLabels = labels;
      stateChartData = [chartData];

      // Set data for session dropdowns
      const player = getPlayerOption(playerId, dropdownOptions);

      breakdownPlayerOptions = player ? [player] : [];
      selectedSession = labels[(labels.length - 1)];
    }
    setProgrammeStatsData(programmeStatsData);
    setLastIndexSessionsLabels([chartLabels]);
    setLastIndexSessionsData(stateChartData)
    setSessionsBatchInView(1);
    setBreakdownPlayerOptions(breakdownPlayerOptions);
    setSessionDropdownOptions(sessionDropdownOptions);
    setAllSessionDropdownOptions(allSessionDropdownOptions);
    setSelectedSession(selectedSession);


    // Set index breakdown stats
    setIndexBreakdownStats(indexBreakdownData ? indexBreakdownData : {});
  };


  const getPlayerOption = (id, dropdownOptions) =>
  {
    // Return the player object for the selected id
    const playerIdx = getOptionIndex(id, dropdownOptions);
    return dropdownOptions[playerIdx];
  };
  const getOptionIndex = (id, options) => options.findIndex(el => Number(el.value) === Number(id));

  const handleBannerClose = () =>
  {
    setError({
      show: false,
      message: '',
    });
  };

  const setPlayerStats = (drillId, drillStats) =>
  {
    // Set selected drill and stats for first player for player card
    if (drillStats.length > 0)
    {
      const statIndex = drillId ? drillStats.findIndex(el => el.drillId === drillId) : 0;
      setSelectedDrillId(drillStats[statIndex].drillId);
      setSelectedDrillName(drillStats[statIndex].drillName);
    }
  };

  const getDrillOptions = drillStats =>
  {
    // Create array of drill options with correct object props for rendering in tab and menu components
    let drillOptions = [];
    drillStats.forEach(drill =>
    {
      const option = {
        id: drill.drillId,
        icon: drill.drillLogo,
        label: drill.drillName,
      }
      drillOptions.push(option);
    });
    return drillOptions;
  };



  const setDrillData = (drillStats, drillId) =>
  {
    const drillOptions = getDrillOptions(drillStats);
    // Set selected drill option and player one drill stats
    setPlayerStats(drillId, drillStats);
    // Split drillOptions depending on length and screen width

  };

  // const getAvgGameStats = (toggleStats, playerScores, worldbestScores)  => {
  //   // Get initial avg stats to display in Average Index Stats section on page load (for logged in player)
  //   toggleStats.forEach((option) => {
  //     // Reset scores and worldScore values before setting initial stats
  //     option.playerScores = [];
  //     option.worldScore = '';
  //     const playerScore = Math.round(playerScores[option.id]);
  //     const worldScore = Math.round(worldbestScores[option.id]);
  //     option.playerScores.push(playerScore);
  //     option.worldScore = worldScore;
  //   });
  //   return {toggleStats};
  // };

  const getDrillAvgGameStats = (toggleStats, drillScores) =>
  {

    // Get initial avg stats to display in Average Index Stats section on page load (for logged in player)
    const avgGameStats = drillScores.map((drillScore) =>
    {
      // Filter to only render stats that we we need for each drill type
      const filteredToggleStats = toggleStats.filter((stat) => Object.keys(drillScore).includes(stat.id));
      return {
        id: drillScore.drillId,
        stats: filteredToggleStats.map((option) =>
        {
          // Reset scores and worldScore values before setting initial stats
          return {
            ...option,
            playerScores: [drillScore[option.id].player && !isNaN(drillScore[option.id].player) ? Number(drillScore[option.id].player).toFixed(2) : drillScore[option.id].player],
            worldScore: drillScore[option.id].global && !isNaN(drillScore[option.id].global) ? Number(drillScore[option.id].global).toFixed(2) : drillScore[option.id].global,
          }
        })
      }
    });
    return avgGameStats;
    // toggleStats.forEach((option) => {
    //   // Reset scores and worldScore values before setting initial stats
    //   option.playerScores = [];
    //   option.worldScore = '';
    //   const playerScore = Math.round(playerScores[option.id]);
    //   const worldScore = Math.round(worldbestScores[option.id]);
    //   option.playerScores.push(playerScore);
    //   option.worldScore = worldScore;
    // });
    // return {toggleStats};
  };

  const getIndexChartData = (programmeId, playerName, sessionStats) =>
  {
    // Set chart data for selected programme
    const labels = [];
    const scores = [];
    const desiredLength = 10;
    sessionStats && sessionStats[programmeId].scores.forEach((score, idx) =>
    {
      labels.push(formatDate(score.created));
      scores.push(score.score ? score.score : 0);
    });
    if (labels.length < desiredLength)
    {
      // Push empty strings into labels array to give it 10 elements to enable correct chart rendering
      const missingLength = desiredLength - labels.length;
      for (let i = 0; i < missingLength; i++)
      {
        labels.push('');
        scores.push(0);
      }
    }
    // Reverse data arrays to show oldest to newest from left to right in chart
    const reversedLabels = labels.reverse();
    const reversedScores = scores.reverse();
    // Set labels and data
    const chartData = {
      avgColor: '#f00',
      bestScore: sessionStats ? sessionStats[programmeId].average : null,
      color: createColorHex(playerName),
      data: scores,
    };
    return { labels: labels, chartData };
  };

  const getDrillChartData = (sessionStats) =>
  {
    let lookup = {
      'rondo-scan': 'Rondo Scans',
      'colour-combo': 'Color Combos',
      'wolfy-180': 'Wolfy 180',
      'shoulder-sums': 'Shoulder Sums',
      'pressure-pass': 'Pressure Pass',

    };


    // Set chart data for selected programme
    const labels = [];
    const scores = [];
    const interim = {};

    if (sessionStats)
    {
      sessionStats.forEach((stat, idx) =>
      {
        interim[stat.drillId] = {
          labels: lookup[stat.drillId] ? lookup[stat.drillId] : stat.drillId,
          scores: stat.stats[0].avg_score.average
        }


      })
    }

    Object.keys(lookup).forEach(keyName =>
    {
      labels.push(lookup[keyName]);
      scores.push(interim[keyName]?.scores ? interim[keyName] : 0);
    })



    const chartData = {
      color: colors.secondaryOrange,
      data: scores,
    };
    return { labels: labels, chartData };
  };

  const getChartData = (drillId, sessionStats) =>
  {
    // Set chart data for selected programme
    const labels = [];
    const scores = [];
    const desiredLength = 10;
    const selectedChartData = sessionStats.find((entry) => Object.keys(entry)[0] === drillId);
    if (!selectedChartData)
    {
      return {};
    }
    selectedChartData[drillId].scores.forEach(score =>
    {
      labels.push(formatStandardDateString(score.created));
      scores.push(score.score);
    });
    if (labels.length < desiredLength)
    {
      // Push empty strings into labels array to give it 10 elements to enable correct chart rendering
      const missingLength = desiredLength - labels.length;
      for (let i = 0; i < missingLength; i++)
      {
        labels.push('');
        scores.push(0);
      }
    }
    // Reverse data arrays to show oldest to newest from left to right in chart
    const reversedLabels = labels.reverse();
    const reversedScores = scores.reverse();
    // Set labels and data
    const bestScore = selectedChartData[drillId].average ? selectedChartData[drillId].average : reversedScores.reduce(
      (previousValue, currentValue) => previousValue + currentValue,
      0
    ) / scores.length;
    const chartData = {
      avgColor: colors.comparisonRed,
      bestScore,
      color: colors.secondaryOrange,
      data: reversedScores,
    };
    return { labels: reversedLabels, chartData };
  };

  const getCompareStats = (statsList, drillId, key) =>
  {
    let result;
    if (statsList?.compareStats)
    {
      result = statsList.compareStats.find((stat) => stat.drillId === drillId)
    }
    if (result && result[key] !== null)
    {
      return result[key]
    }
    return '-'
  }
  const getDrillStats = (statsList, drillId, statType, name) =>
  {
    let pickedStat;
    if (statsList?.levels)
    {
      pickedStat = statsList.levels.find((stat) => stat.drillId === drillId)
      if (pickedStat.levels)
      {
        if (pickedStat.levels[statType])
        {
          let out = [];
          Object.values(pickedStat.levels[statType]).forEach((item) =>
          {
            let lastStatIndex = item.length - 1,
              value = item[lastStatIndex][name];
            if (!Number.isInteger(value))
            {
              value = Math.round(value * 100) / 100;
            }
            out.push(value);
          });
          return out;
        }

        // return 'nokey'
      }
    }

    return '-'
  }
  const updateChartData = (idx, sessionStatsData) =>
  {

    if (!sessionStatsData[0])
    {
      return;
    }
    const statsData = sessionStatsData[0].find((stat) => stat.drillId === selectedDrillId) || sessionStatsData[0][0];

    const { labels, chartData } = getChartData(
      drillStatsToggleOptions[idx].id,
      statsData.stats
    );

    setDrillSessionStatsData(sessionStatsData);
    //setChartLabels(labels);
    //setChartData([chartData]);
  };

  return (
    <>
      {
        <MainWrapper
          error={error.show}
          apiMessage={error.message}
          handleBannerClose={handleBannerClose}
          activeRoute={routes.indexPrintStats}
          clubLogo={baseContext.baseData.clubProfile.logo}
          dataLoading={false}
          hasEliteLicence={baseContext.baseData.hasEliteLicence}
          hasRezzilPlayerLicence={baseContext.baseData.hasRezzilPlayerLicence}
          licences={baseContext.baseData.licences}
        >
          <Stack id="outer" direction="column" spacing={10} justifyContent="space-between" sx={{ padding: "4em" }}>
            <Stack direction="row" id="upper">
              {selectedPlayer &&
                <React.Fragment>
                  <Stack direction="column" justifyContent="space-between" sx={{ width: "50%", paddingRight: "1em" }}>
                    <Stack direction="column">
                      <Box sx={{ fontSize: "50px", fontWeight: 500 }}>
                        {selectedPlayer.firstname} {selectedPlayer.lastname}
                      </Box>
                      <Box>
                        REZZIL ID - {selectedPlayer.id}
                      </Box>
                      <Box sx={{ fontSize: "1.5em" }} color="#c40049" >
                        {reportDate}
                      </Box>
                    </Stack>
                    <PrintStatsStat
                      name={'Rezzil Index'}
                      stats={[playerAvgData2?.rezzilIndex?.avgScore, 100, playerAvgData2?.rezzilIndex?.oldavgScore]}
                      desc={'Be a great all rounder and increase your Rezzil Index'}
                    />
                    <Box sx={{ fontSize: "38px" }}>
                      LAST 10 INDEX SESSIONS
                    </Box>
                    <BarChartContainer
                      id={'indexSessionsChartContainer'}
                      sx={{ height: "250px" }}
                    >{
                        lastIndexSessionsLabels &&
                        <PrintBarChart
                          key={'0'}
                          loading={indexChartDataLoading}
                          id={'indexSessions'}
                          labels={lastIndexSessionsLabels}
                          data={lastIndexSessionsData}
                          selectedDataset={0}
                        />
                      }
                    </BarChartContainer>
                    <PrintStatsStat
                      id="pss"
                      name={'World Rank'}
                      stats={[playerIndexStatsList && playerIndexStatsList.worldRank]}
                    />
                    <PrintStatsStat
                      name={'Club Rank'}
                      stats={[playerIndexStatsList && playerIndexStatsList.clubRank]}
                    />
                  </Stack>
                  <Stack direction="column" justifyContent="space-between" sx={{ width: "50%", paddingLeft: "1em" }}>
                    <Container sx={{
                      height: "400px",
                      overflow: "hidden"
                    }}>
                      <ChartImage key="player" ident='player' width={400} />
                      <RadarChartContainer
                        id={'playerChartContainer'} sx={{
                          width: "400px",
                          margin: 'auto'
                        }}
                      >
                        <PrintRadarChart
                          loading={playerDataLoading}
                          id={'player'}
                          firstDataset={playerAvgData}
                          secondDataset={playerAvgDataArr.length > 1 ? playerAvgDataArr[1] : undefined}
                          datasetArray={playerAvgDataArr}
                          colourArray={[colors.primaryRed, colors.secondaryRedOpaque]}
                        />
                      </RadarChartContainer>
                    </Container>
                    <PrintStatsStat
                      name={'Composure'}
                      desc={'Keep your accuracy under pressure to improve'}
                      stats={[playerAvgData2?.composure?.avgScore, 100, playerAvgData2?.composure?.oldavgScore]}
                    />
                    <PrintStatsStat
                      name={'Reaction'}
                      desc={'Make decisions quicker and this score will go up'}
                      stats={[playerAvgData2?.reaction?.avgScore, 100, playerAvgData2?.reaction?.oldavgScore]}
                    />
                    <PrintStatsStat
                      name={'Accuracy'}
                      desc={'Improve your shot success rate to boost this score'}
                      stats={[playerAvgData2?.accuracy?.avgScore, 100, playerAvgData2?.accuracy?.oldavgScore]}
                    />
                    <PrintStatsStat
                      name={'Completeness'}
                      desc={'Use both feet to improve this score'}
                      stats={[playerAvgData2?.adaptability?.avgScore, 100, playerAvgData2?.adaptability?.oldavgScore]}
                    />
                  </Stack>
                </React.Fragment>
              }
            </Stack>
            <div id="leaderboard">
              <Stack direction="row" spacing={0} justifyContent="space-between">
                <PrintStatsLeaderboard
                  keyP="leaderboards"
                  title="Leaderboards"
                  dataHeaders={["Drill", "Rank"]}
                  data={[
                    ["Rondo Scan", (playerIndexStatsList && getCompareStats(playerStatsList, 'rondo-scan', 'worldRank'))],
                    ["Color Combo", (playerStatsList && getCompareStats(playerStatsList, 'colour-combo', 'worldRank'))],
                    ["Shoulder Sums", (playerStatsList && getCompareStats(playerStatsList, 'shoulder-sums', 'worldRank'))],
                    ["Wolfy", (playerStatsList && getCompareStats(playerStatsList, 'wolfy-180', 'worldRank'))],
                    ["Pressure Pass", (playerStatsList && getCompareStats(playerStatsList, 'pressure-pass', 'worldRank'))],
                  ]}
                />
                <PrintStatsLeaderboard
                  keyP="rondo-scan"
                  title="Rondo Scan"
                  dataHeaders={["Level", ...Array.from({ length: getDrillStats(playerStatsList, 'rondo-scan', 'index', 'score').length }, (_, i) => i + 1)]}
                  data={[
                    ["Score",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'rondo-scan', 'index', 'score')),

                    ],
                    ["Goals",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'rondo-scan', 'index', 'goals')),
                    ],
                    ["Left Foot",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'rondo-scan', 'index', 'left_foot_shots')),

                    ],
                    ["Right Foot",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'rondo-scan', 'index', 'right_foot_shots')),

                    ],
                    ["Avg. Dwell",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'rondo-scan', 'index', 'average_dwell')),

                    ],
                  ]}
                />
                <PrintStatsLeaderboard
                  keyP="colour-combo"
                  title="Color Combo"
                  dataHeaders={["Level", ...Array.from({ length: getDrillStats(playerStatsList, 'colour-combo', 'index', 'score').length }, (_, i) => i + 1)]}
                  data={[
                    ["Score",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'colour-combo', 'index', 'score')),

                    ],
                    ["Correct",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'colour-combo', 'index', 'correct')),

                    ],
                    ["Incorrect",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'colour-combo', 'index', 'incorrect')),

                    ],
                    ["Missed",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'colour-combo', 'index', 'missed')),

                    ],
                    ["Platinum",

                      ...(playerStatsList && getDrillStats(playerStatsList, 'colour-combo', 'index', 'platinum')),

                    ],
                  ]}
                />
              </Stack>
              <Stack direction="row" spacing={5} justifyContent="space-between">
                <PrintStatsLeaderboard
                  keyP="wolfy"
                  title="wolfy"
                  dataHeaders={["Level", ...Array.from({ length: getDrillStats(playerStatsList, "wolfy-180", 'index', 'score').length }, (_, i) => i + 1)]}
                  data={[
                    ["Score",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'wolfy-180', 'index', 'score')),

                    ],
                    ["Correct",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'wolfy-180', 'index', 'correct')),

                    ],
                    ["Incorrect",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'wolfy-180', 'index', 'incorrect')),
                    ],
                    ["Avg. Decision",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'wolfy-180', 'index', 'average_decision_time')),

                    ],
                  ]}
                />
                <PrintStatsLeaderboard
                  keyP="pressure-pass"
                  title="pressure pass"
                  dataHeaders={["Level", ...Array.from({ length: getDrillStats(playerStatsList, "pressure-pass", 'index', 'score').length }, (_, i) => i + 1)]}
                  data={[
                    ["Score",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'pressure-pass', 'index', 'score')),

                    ],
                    ["Correct",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'pressure-pass', 'index', 'correct')),

                    ],
                    ["Incorrect",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'pressure-pass', 'index', 'incorrect')),

                    ],
                    ["Avg. Dwell",
                      ...(playerStatsList && getDrillStats(playerStatsList, 'pressure-pass', 'index', 'average_dwell')),

                    ],
                  ]}
                />
                <PrintStatsLeaderboard
                  keyP="shoulder-sums"
                  title="Shoulder Sums"
                  dataHeaders={["Level", ...Array.from({ length: getDrillStats(playerStatsList, "shoulder-sums", 'index', 'score').length }, (_, i) => i + 1)]}
                  data={[
                    ["Score",
                      ...(playerStatsList && getDrillStats(playerStatsList, "shoulder-sums", 'index', 'score')),

                    ],
                    ["Goals",
                      ...(playerStatsList && getDrillStats(playerStatsList, "shoulder-sums", 'index', 'goals')),

                    ],
                    ["Timeouts",
                      ...(playerStatsList && getDrillStats(playerStatsList, "shoulder-sums", 'index', 'timeout')),

                    ],
                    ["Avg. Dwell",
                      ...(playerStatsList && getDrillStats(playerStatsList, "shoulder-sums", 'index', 'average_dwell')),

                    ],
                  ]}
                />
              </Stack>
            </div>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ borderTop: `1px ${colors.printStatsRed} solid`, paddingTop: "1em" }}
            >
              <RezzilLogoBlack />
              <Box>www.rezzil.com</Box>
            </Stack>
          </Stack>
        </MainWrapper >
      }
    </>
  );
};

export default PrintStats;
